import React from 'react'

const servicesArr = [
    // {
    //     img: require("../img/serviceImg1.svg").default,
    //     title: "2000+",
    //     subTitle: "Patients",
    //     detail: "being cared for",
    // },
    {
        img: require("../img/serviceImg4.svg").default,
        title: "57%",
        subTitle: "Reduction",
        detail: "in 30-day admission rate",
        imgStyle: { transform: 'scaleY(-1)', mixBlendMode: 'multiply' },
    },
    {
        img: require("../img/serviceImgHospital.svg").default,
        title: "50%",
        subTitle: "Reduction",
        detail: "in hospitalizations (published research*)",
        flipImg: true,
    },
    {
        img: require("../img/serviceImg4.svg").default,
        title: "10X",
        subTitle: "Increase",
        detail: "in access to home-based clinical care upon timely triage",
    },
    {
        img: require("../img/serviceImg5.svg").default,
        title: "75%",
        subTitle: "Ongoing",
        detail: "symptom reporting rates",
    },
    // {
    //     img: require("../img/serviceImgEngagement.svg").default,
    //     title: "35%",
    //     subTitle: "Engagement",
    //     detail: "per week",
    //     imgStyle: { transform: 'scale(1.8)', mixBlendMode: 'multiply' },
    // },
    {
        img: require("../img/serviceImg2.svg").default,
        title: ">60%",
        subTitle: "Engagement",
        detail: "above 6 months",
    },
    {
        img: require("../img/serviceImgEngagement.svg").default,
        title: ">52%",
        subTitle: "Continuously",
        detail: "engaged in goals of care conversations",
        imgStyle: { transform: 'scale(2)', mixBlendMode: 'multiply' },
    },
]
const Service = (props) => {
    return (
        <div className='servicesWrap'>
            <div class="container">
                <h1>{props.title}</h1>
                <ul>
                    {
                        servicesArr.map((servicesData) => (
                            <li>
                                <div className='serviceImg'><img src={servicesData.img} alt='' style={servicesData.imgStyle || (servicesData.flipImg ? { transform: 'scaleY(-1)' } : {})} /></div>
                                <h1>{servicesData.title}</h1>
                                <span>{servicesData.subTitle}</span>
                                <p>{servicesData.detail}</p>
                            </li>
                        ))
                    }
                </ul>
                
            </div>
            
        </div>
    )
}

export default Service
